import React from "react";
import { StyleSheet, View, Pressable } from "react-native";

//Custom Imports
import Bell from "@assets/svg/Bell";
import color from "@constants/color";
import { scale } from "@utils/scale";
import t from "@constants/localization";
import CustomText from "@components/CustomText";
import { getDayMonthContestUpdate } from "../ContestEvents";

const PATH = "screens/Contest/contestDetails";

const ContestUpdate = ({ item = {}, language = "", navigation }) => {
  const {
    payout_time = "",
    payout_type,
    payouts_by_rank,
    payout_done = false,
    payout_transaction_id = null,
    payout_amount = 0,
  } = item;

  const onPressUpdate = () => {
    if (payout_done && navigation) navigation.navigate("Gullak");
  };

  return (
    <View style={styles.container}>
      <CustomText
        variant="subtitle_16"
        newfont={true}
        numberOfLines={1}
        style={styles.titleText}
      >
        {t(`${PATH}/contestUpdate`)}
      </CustomText>
      <Pressable onPress={onPressUpdate} style={styles.yourTaskCard}>
        <Bell style={styles.bellStyle} fillColor={color.orange_rgba_107} />
        <CustomText
          variant="body_text_3"
          newfont={true}
          style={styles.descriptionText}
        >
          {parseInt(payout_amount) === 0
            ? t(`${PATH}/notParticipated`)
            : payout_done
              ? t(`${PATH}/paymentDoneMessage`)
              : t(`${PATH}/contestUpdateMessage`, {
                  interval: payout_time
                    ? getDayMonthContestUpdate(payout_time, language)
                    : "",
                })}
        </CustomText>
      </Pressable>
    </View>
  );
};

export default ContestUpdate;

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    paddingHorizontal: 16,
    marginTop: 15,
  },
  titleText: {
    color: color.mediumBlack,
  },
  yourTaskCard: {
    flexDirection: "row",
    elevation: 8,
    shadowColor: color.mediumBlack,
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4.65,
    borderRadius: scale(10),
    backgroundColor: color.white,
    marginTop: 8,
    padding: 16,
  },
  descriptionText: {
    color: color.mediumBlack,
    marginStart: 16,
    maxWidth: scale(260),
  },
  bellStyle: {
    marginTop: 4,
  },
});
